module.exports = __webpack_public_path__ + "assets/img/1.34f90278.png";